import { Fragment } from 'react';

export default function AccountScope({ user, children }) {
  const key = JSON.stringify([user?.id, user?.role, user?.company_id, user?.partner_id,
    user?.profile_test?.actor_id, user?.profile_test?.target_user_id]
    .map(value => typeof value === 'string' ? value : ''));
  return <Fragment key={key}>{children}</Fragment>;
}
